import React, {useEffect, useState} from 'react'
import { inputTypes } from '../../../libs/react-mpk/config/constant'
import { FormWrapper } from '../../../libs/react-mpk/wrapper'
import t from 'counterpart'
import { inject, observer } from 'mobx-react'
import service from './Negara.service'

const NegaraForm = ({envStore, match, history}) => {
  const { inputTypes, definition } = FormWrapper
  const [isEdit, setIsEdit] = useState(false)
  const [data, setData] = useState({loading: true, content: {}})

  // initial data
  useEffect(() => {
    async function initData() {
      if(match.params.id == 'baru') {
        setData({loading: false, content: {}})
        return true
      }
      const res = await service.getOne(match.params.id)
      setData({loading: false, content:res.data})
      setIsEdit(true)
    }
    initData()
  }, ['match.params.id'])

  return (
    <FormWrapper
      noValidate
      customRules={{
        kode1: 'required|size:3',
        kode2: 'required|size:2',
        nama: 'required'
      }}
      loading={data.loading}
      actions={[
        {
          label: 'Reload',
          iconClassName: 'mdi mdi-reload'
        }
      ]}
      backTo={`/onpremise/negara`}
      baseId="mod-form-sample"
      title={t.translate('modules.negara.formTitle')}
      // hintMessage={t.translate('modules.form.hint.message')}
      hintShowIcon={false}
      defaultData={data.content}
      definitions={[
        // =====
        {
          inputType: inputTypes.INPUT,
          label: 'Nama Negara',
          key: 'nama',
          type: 'text',
          required: true,
          disabled: isEdit
        },{
          inputType: inputTypes.INPUT_MASK,
          label: 'Kode Negara (3digit)',
          key: 'kode1',
          type: 'text',
          mask: '***',
          alwaysShowMask: true,
          width: '49%',
          style: {marginRight: '2%'},
          required: true,
          // disabled: isEdit
        },{
          inputType: inputTypes.INPUT_MASK,
          label: 'Kode Negara (2digit)',
          key: 'kode2',
          type: 'text',
          mask: '**',
          alwaysShowMask: true,
          width: '49%',
          required: true,
          // disabled: isEdit
        },{
          inputType: inputTypes.INPUT,
          label: 'Keterangan',
          key: 'keterangan',
          type: 'text'
        },
        // -----
      ]}
      onSubmit={async (data, callback) => {
        var res = {}
        try {
          if(match.params.id == 'baru') {
            res = await service.post(data)
          } else {
            res = await service.put(data)
          }
          callback(t.translate('global.dataTelahDiSimpan'), false)
          history.push('/onpremise/negara')
        } catch(e) {
          callback(e, true, false)
        }
      }}
    />
  )
}

export default inject('envStore')(observer(NegaraForm))
